import { PromptTemplate } from '../../../types/types'
import { SearchSnippet } from './types'

const SNIPPET_RADIUS = 50

/** True when the query appears in the template's label, key, or (draft) content - case-insensitive. */
export function templateMatches(tpl: PromptTemplate, content: string, query: string): boolean {
  const q = query.trim().toLowerCase()
  if (!q) return true
  return (
    tpl.label.toLowerCase().includes(q) ||
    tpl.key.toLowerCase().includes(q) ||
    content.toLowerCase().includes(q)
  )
}

/** First occurrence of the query in the content, with surrounding context for display. */
export function findSnippet(content: string, query: string): SearchSnippet | null {
  const q = query.trim()
  if (!q) return null
  const index = content.toLowerCase().indexOf(q.toLowerCase())
  if (index === -1) return null
  const start = Math.max(0, index - SNIPPET_RADIUS)
  const end = Math.min(content.length, index + q.length + SNIPPET_RADIUS)
  return {
    before: (start > 0 ? '…' : '') + content.slice(start, index),
    match: content.slice(index, index + q.length),
    after: content.slice(index + q.length, end) + (end < content.length ? '…' : ''),
    index,
  }
}

/** Splits text around every case-insensitive occurrence of the query, for <mark> rendering. */
export function splitByQuery(text: string, query: string): { text: string; isMatch: boolean }[] {
  const q = query.trim()
  if (!q) return [{ text, isMatch: false }]
  const parts: { text: string; isMatch: boolean }[] = []
  const lower = text.toLowerCase()
  const needle = q.toLowerCase()
  let pos = 0
  for (let i = lower.indexOf(needle); i !== -1; i = lower.indexOf(needle, pos)) {
    if (i > pos) parts.push({ text: text.slice(pos, i), isMatch: false })
    parts.push({ text: text.slice(i, i + q.length), isMatch: true })
    pos = i + q.length
  }
  if (pos < text.length) parts.push({ text: text.slice(pos), isMatch: false })
  return parts
}
